/**
 * Interfaces para etapas BNCC (EI, EF, EM, etc.)
 */

import { Bncc, Config } from './bncc.model';

export interface EtapaV2 {
  CONFIG: Config[];
  BNCC: Bncc[];
}

export interface EtapaEI {
  ID_PLANO_AULA: number;
  ID_PLANO_AULA_HAB: number;
  ID_BNCC_EI: number;
  COMPONENTE: string;
  OBJETIVOAPRENDIZAGEM: string;
}

export type ListaEtapaEI = EtapaEI[];

export interface EtapaEF {
  ID_PLANO_AULA: number;
  ID_PLANO_AULA_HAB: number;
  ID_BNCC_EF: number;
  OBJETOCONHECIMENTO: string;
  CODHABILIDADE: string;
  HABILIDADE: string;
  COMPONENTE: string;
  UNIDADETEMATICA: string;
}

export type ListaEtapaEF = EtapaEF[];

export interface EtapaEM {
  [key: string]: unknown;
}

export type ListaEtapaEM = EtapaEM[];

export interface EtapaDIV {
  ID_PLANO_AULA_AUX: number;
  ID_PLANO_AULA: number;
  CAMPO1: string;
  CAMPO2?: string;
  DATACADASTRO: string;
  DATAATUALIZADO: string;
  NOMEUSUARIO: string;
  CDDISC: number;
  ID_ERGON: number;
  DSDISC: string;
}

export type ListaEtapaDiv = EtapaDIV[];
